import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import { Tabs, Tab } from "@mui/material";
import BillDetailsPaymentTable from "components/billdetailspayment/BillDetailsPaymentTable";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import useFilter from "hooks/useFilter";
import { useState, useEffect, useContext } from "react";
import BillDetailsPaymentServices from "services/BillDetailsPaymentServices";

import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import { SidebarContext } from "context/SidebarContext";
import Somethingwentwrong from "pages/Somethingwentwrong";

import sidebar from "routes/sidebar";
import LabelArea from "components/form/LabelArea";
import InputSearchDate from "components/form/InputSearchDate";
// import ExportData from 'components/common/ExportData';
import ExportDataXlsx from "components/common/ExportDataXlsx";

import { useLocation } from "react-router-dom";

const BillDetailsPayment = () => {
  const location = useLocation();
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const id_employee = adminInfo?.id ? adminInfo.id : 0;
  const [loading, setLoading] = useState(false);
  const { isUpdate, setIsUpdate } = useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tab, setTab] = useState(0);
  const [billdetailspaymentData, setBillDetailsPaymentData] = useState([]);
  const [status, setStatus] = useState(false);
  const [error, setError] = useState(false);
  const [exportingData, setExportingData] = useState([]);

  const {
    billdetailspaymentRef,
    dataTable,
    serviceData,
    handleSubmitBillDetailsPayment,
    currentPage,
  } = useFilter(billdetailspaymentData, itemsPerPage);

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);

  const groupedData = billdetailspaymentData.reduce((acc, row) => {
    // Generate a normalized key by trimming and converting to lowercase
    const key = `${row.ref_no?.trim().toLowerCase()}-${row.client_name
      ?.trim()
      .toLowerCase()}-${row.vendor_name
      ?.trim()
      .toLowerCase()}-${row.start_date?.trim()}-${row.arrival
      ?.trim()
      .toLowerCase()}-${row.departure?.trim().toLowerCase()}-${row.vehicle_type
      ?.trim()
      .toLowerCase()}`;

    if (!acc[key]) {
      // Create a new group if the key does not exist
      acc[key] = {
        ...row,
        trip_advance_request: [row.trip_advance_request], // Store requests in an array
        approval_status: [row.approval_status],
        paid_status: [row.paid_status], // Store paid amounts in an array
      };
    } else {
      // Push the new values to the existing arrays
      acc[key].trip_advance_request.push(row.trip_advance_request);
      acc[key].paid_status.push(row.paid_status);
      acc[key].approval_status.push(row.approval_status);
    }

    return acc;
  }, {});
  // Assuming groupedData is already defined as in your code
  for (const refNo in groupedData) {
    if (groupedData.hasOwnProperty(refNo)) {
      // const tripAdvanceRequestArray = groupedData[refNo].trip_advance_request;
      // Calculate the total of all trip_advance_request values for this ref_no
      // const totalTripAdvanceRequest = tripAdvanceRequestArray.reduce(
      //   (sum, amount) => sum + amount,
      //   0
      // );
    }
  }

  // const groupedArray = Object.values(groupedData);

  const [searchstartDate, setSearchStartDate] = useState(null);
  const [searchendDate, setSearchEndDate] = useState(null);
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const formattedDates = {
    start_date: searchstartDate ? formatDate(searchstartDate) : "",
    end_date: searchendDate ? formatDate(searchendDate) : "",
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const urlType = params.get("type");
    if (urlType !== null) {
      const parsed = Number(urlType);
      if (!isNaN(parsed) && parsed >= 1 && parsed <= 4) {
        setTab(parsed - 1);
      }
    }

    const start = params.get("start");
    const end = params.get("end");

    if (start && end) {
      const parseDate = (str) => {
        const [dd, mm, yyyy] = str.split("-");
        return new Date(yyyy, mm - 1, dd);
      };

      setSearchStartDate(parseDate(start));
      setSearchEndDate(parseDate(end));
    }
  }, [location.search]);

  // const totalResults = groupedArray.length;

  useEffect(() => {
    const fetchBillDetailsPayment = async () => {
      setLoading(true);
      // var date = {
      //   from: formattedDates.start_date,
      //   to: formattedDates.end_date,
      // };
      try {
        let response;
        if (tab === 0) {
          let payload = {
            from: formattedDates.start_date,
            to: formattedDates.end_date,

            type: 1,

            employee_id: id_employee,
          };

          response =
            await BillDetailsPaymentServices.billdetailspaymentRequestList(
              payload,
            );
        } else if (tab === 1) {
          let payload = {
            from: formattedDates.start_date,
            to: formattedDates.end_date,

            type: 2,

            employee_id: id_employee,
          };
          response =
            await BillDetailsPaymentServices.billdetailspaymentRequestList(
              payload,
            );
        } else if (tab === 2) {
          let payload = {
            from: formattedDates.start_date,
            to: formattedDates.end_date,

            type: 3,

            employee_id: id_employee,
          };
          response =
            await BillDetailsPaymentServices.billdetailspaymentRequestList(
              payload,
            );
        } else if (tab === 3) {
          let payload = {
            from: formattedDates.start_date,
            to: formattedDates.end_date,

            type: 4,

            employee_id: id_employee,
          };
          response =
            await BillDetailsPaymentServices.billdetailspaymentRequestList(
              payload,
            );
        }
        const updatedData =
          response?.data?.map(
            ({
              id,
              agent_name,
              client_name,
              va_start_date,
              ref_no,
              vehicle_type,
              vendor_name,
              trip_advance_request,
              trip_advance_paid,
              bill_adjusted_amount,
              approval_status,
              paid_status,
              paid_remark,
              bill_amount,

              ...rest
            }) => ({
              id,
              agent_name,
              client_name,
              va_start_date,
              ref_no,
              vehicle_type,
              vendor_name,
              trip_advance_request,
              trip_advance_paid,
              bill_adjusted_amount,
              approval_status,
              paid_status,
              paid_remark,
              bill_amount,
              ...rest,
            }),
          ) || [];
        // console.log("datas", updatedData);

        setBillDetailsPaymentData(updatedData);
        setStatus(response?.status);
        setLoading(false);

        const finalData = response?.data?.map((item, index) => {
          return {
            "SI.No": index + 1,
            "Ref.No": item.ref_no,
            Vendor: item.vendor_name,
            "Client Name": item.client_name,
            "Start Date": item.start_date,
            "End Date": item.end_date,
            Arrival: item.arrival,
            Departure: item.departure,
            "Bill Added Days": item.days_difference || 0,
            "Bill Amount": item.bill_amount || 0,
            "Trip Advance": item.trip_advance_paid || 0,
            TDS: item.TDS,
            "Total Payable Amount": item.net_payable_amount || 0,

            "Payment History":
              item?.payment_history
                ?.map(
                  (payment) =>
                    `Amount: ${payment?.amount || 0}, ` +
                    // `Date: ${payment?.paid_date ? new Date(payment.paid_date).toLocaleDateString("en-IN") : ""}, ` +
                    // `Type: ${payment?.type || ""}, ` +
                    // `Payment Type: ${payment?.payment_type || ""}, ` +
                    // `UTR: ${payment?.utr || ""}, ` +
                    `Pending Before: ${payment?.pending_before || 0}, ` +
                    `Adjusted Amount: ${payment?.adjusted_amount || 0}, ` +
                    `Running Balance: ${payment?.running_balance || 0}, ` +
                    // `Adjustments: ${JSON.stringify(payment?.adjustments || [])}`,
                    `Adjustments: ${
                      payment?.adjustments?.length
                        ? JSON.stringify(payment.adjustments)
                        : 0
                    }`,
                )
                .join(" | ") || "",
            "Paid Amount":
              item?.payment_history?.reduce(
                (total, payment) => total + (Number(payment?.amount) || 0),
                0,
              ) || 0,
          };
        });
        // console.log("data final", finalData);
        setExportingData(finalData);
      } catch (error) {
        setLoading(false);
        setError(true);
        console.error("Error fetching billdetailspayment:", error);

        // notifyError("Failed to fetch billdetailspayment. Please try again later.");
      }
    };
    if (!isUpdate && location.search && !searchstartDate && !searchendDate) {
      // console.log("Skipping initial fetch — waiting for URL date parsing");
      return;
    }
    fetchBillDetailsPayment();
    setIsUpdate(false);
    // eslint-disable-next-line
  }, [tab, isUpdate, searchstartDate, searchendDate]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const handleSearch = () => {
    setIsUpdate(true);
  };
  // const totalResults = filteredAgents.length;

  // Slice data for the current page
  // const paginatedBillDetailsPayment = groupedArray.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage
  // );
  // const paginatedBillDetailsPayment = groupedArray.slice(
  //   (currentPage - 1) * perpage,
  //   currentPage * perpage
  // );

  // const hideView = adminInfo?.permission?.some(
  //   (perm) => perm.id_tab === "billdetailspayment" && perm.view === 1
  // );
  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "bill details payment" && perm.view === 1,
      );
  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "bill details payment" && perm.edit === 1,
      );
  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "bill details payment" && perm.export === 1,
      );

  const getTabName = () => {
    if (tab === 0) return "Unpaid";
    if (tab === 1) return "Ready_To_Pay";
    if (tab === 2) return "Paid";
    if (tab === 3) return "All";
    return "";
  };
  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <PageTitle sidebar={sidebar().sidebar} />
          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
            <CardBody>
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2">
                    <LabelArea label="Start Date" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchstartDate}
                        onChange={(event) => setSearchStartDate(event)}
                      />
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <LabelArea label="End Date" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchendDate}
                        min={searchstartDate}
                        onChange={(event) => setSearchEndDate(event)}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-1">
                  <Input
                    ref={billdetailspaymentRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    placeholder="Quick Search"
                    onChange={handleSubmitBillDetailsPayment}
                  />
                </div>

                <div>
                  <Button
                    className="rounded-md h-10 px-8"
                    onClick={() => {
                      handleSearch();
                    }}
                  >
                    Search
                  </Button>
                </div>
                {hideExport && (
                  <ExportDataXlsx
                    title="Bill Details Payment"
                    exportDataXlsx={exportingData}
                    fileNames={`BillDetailsPayment_${getTabName()}`}
                    startDate={searchstartDate}
                    endDate={searchendDate}
                  />
                )}
              </div>
            </CardBody>
          </Card>
          <Tabs
            value={tab}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { backgroundColor: "#057a55" },
            }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "capitalize",
              },
            }}
          >
            {/* <Tab label="All" /> */}
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Unpaid"
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Ready To Pay"
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Paid"
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="All"
            />
          </Tabs>
          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length !== 0 ? (
              <TableContainer>
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "67vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="capitalize z-10 text-center sticky top-0 text-sm">
                      {tab !== 1 && (
                        <tr>
                          <TableCell>Sl.No.</TableCell>
                          <TableCell>Ref. No. </TableCell>
                          <TableCell>Client Name</TableCell>
                          <TableCell>Travel Date</TableCell>
                          <TableCell>Arrival</TableCell>
                          <TableCell>Vendor</TableCell>
                          {/* <TableCell>Trip Date</TableCell> */}
                          <TableCell>Bill Amount</TableCell>
                          <TableCell>Bill Added Days</TableCell>
                          <TableCell>TDS</TableCell>
                          <TableCell>Trip Advance</TableCell>
                          {tab !== 2 && (
                            <TableCell>Total Payable Amount</TableCell>
                          )}

                          <TableCell>Bill</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Payment History</TableCell>
                          {tab !== 2 && <TableCell>Action</TableCell>}
                        </tr>
                      )}
                      {tab === 1 && (
                        <tr>
                          <TableCell>Sl.No.</TableCell>
                          <TableCell>Vendor</TableCell>
                          <TableCell>Ref. No.</TableCell>
                          <TableCell>Client Name</TableCell>
                          <TableCell>Travel Date</TableCell>
                          <TableCell>Arrival</TableCell>
                          {/* <TableCell>Trip Date</TableCell> */}
                          <TableCell>Bill Amount</TableCell>
                          <TableCell>Bill Added Days</TableCell>
                          <TableCell>TDS</TableCell>
                          <TableCell>Trip Advance</TableCell>
                          <TableCell>Total Payable Amount</TableCell>
                          <TableCell>Bill</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Payment History</TableCell>
                          <TableCell>Action</TableCell>
                        </tr>
                      )}
                    </TableHeader>
                    <BillDetailsPaymentTable
                      billdetailspayment={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      tab={tab}
                      hideEdit={hideEdit}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <>
                {status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Bill Details Payment." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default BillDetailsPayment;
